import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { router } from './router'
import './styles/index.css'

async function boot() {
  if (import.meta.env.VITE_MOCK === '1') {
    const { installMocks } = await import('./shared/testing/mock-api')
    installMocks()
  }
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <RouterProvider router={router} />
    </StrictMode>,
  )
}

void boot()
